import basketService from '../../../../general/js/basket/basket-service';
import * as types from './action-types';
import * as apiResponseMessages from './api-response-messages';
import { beginApiCall, apiCallError } from './api-status-actions';

export function purchaseAttemptSuccess(purchaseAttemptMessages) {
    return { type: types.PURCHASE_ATTEMPT_SUCCESS, purchaseAttemptMessages };
}

export function purchaseAttemptError(purchaseAttemptMessages) {
    return { type: types.PURCHASE_ATTEMPT_ERROR, purchaseAttemptMessages };
}

export function resetUpgradeAccountFormState() {
    return { type: types.RESET_UPGRADE_ACCOUNT_FORM };
}

export function retryPurchase() {
    const products = localStorage.getItem('ticketBasket2019');
    return function (dispatch) {
        dispatch(beginApiCall());
        basketService.checkout(products, false)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(purchaseAttemptError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                    return;
                }

                dispatch(purchaseAttemptSuccess([apiResponseMessages.UPGRADE_TO_TICKETING_ACCOUNT_SUCCESSFULLY]));
            }).catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(purchaseAttemptError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}
